import debounce from "lodash/debounce";
import PropTypes from "prop-types";
import React from "react";
import { Box, Dropdown, Text } from "samba-ui";
import { searchByType } from "../../../../actions/metadata";
import { supportsBrandFiltering } from "../../../../constants";
import { HelperText, Label, StyledMainContainer } from "./../styles";
import { RadioWrapper, SelectedContentContainer } from "./styles";

const filters = [
  {
    label: "Parents",
    value: "parent",
    feedValue: "included_parents",
    search: "parentSearchVal",
  },
  {
    label: "Advertisers",
    value: "advertiser",
    feedValue: "included_advertisers",
    search: "advertiserSearchVal",
  },
  {
    label: "Brands",
    value: "brand",
    feedValue: "included_brands",
    search: "brandSearchVal",
  },
  {
    label: "Products",
    value: "product",
    feedValue: "included_products",
    search: "productSearchVal",
  },
];

class IncludedContent extends React.Component {
  state = {
    brandSearchVal: "",
    parentSearchVal: "",
    advertiserSearchVal: "",
    productSearchVal: "",
    selectedCountry: null,
  };

  componentDidMount() {
    if (this.props.feed.type && !supportsBrandFiltering(this.props.feed.type)) {
      this.props.onChangeBrandsSelection(true);
    }
  }

  searchForDebounced = debounce(
    (type, searchVal, country) =>
      new Promise(async (resolve) => {
        const result = await searchByType(type, searchVal, country);
        return resolve(result);
      }, 500)
  );

  render() {
    const { feed, onChangeFeed, includeAllBrands, onChangeBrandsSelection } =
      this.props;

    return (
      <StyledMainContainer>
        <Label>Included content</Label>
        <HelperText>Select brands to include in the file.</HelperText>
        <RadioWrapper disabled={feed.type === "unexposed"}>
          <Box
            as="input"
            type="radio"
            checked={includeAllBrands}
            onChange={() => onChangeBrandsSelection(true)}
          />
          <Label>All brands</Label>
        </RadioWrapper>
        <RadioWrapper disabled={feed.type && !supportsBrandFiltering(feed.type)}>
          <Box
            as="input"
            type="radio"
            checked={!includeAllBrands}
            onChange={() => onChangeBrandsSelection(false)}
          />
          <Label>Filter By</Label>
        </RadioWrapper>
        {!includeAllBrands && (
          <Box>
            {filters.map(({ label, value, feedValue, search }) => (
              <SelectedContentContainer key={label}>
                <Text>{label}:</Text>
                <Box width={300}>
                  <Dropdown
                    isAsync
                    isMulti
                    loadOptions={(val) =>
                      this.searchForDebounced(
                        value,
                        val,
                        feed.country.value || feed.country
                      )
                    }
                    options={[
                      { label: this.state[search], value: this.state[search] },
                    ]}
                    placeholder="Select..."
                    selected={feed[feedValue]}
                    onSelect={(selections) => {
                      // Will return `null` if none are selected, but we want []
                      onChangeFeed(feedValue, selections || []);
                    }}
                  />
                </Box>
              </SelectedContentContainer>
            ))}
          </Box>
        )}
      </StyledMainContainer>
    );
  }
}

IncludedContent.propTypes = {
  feed: PropTypes.shape({
    name: PropTypes.string,
    included_brands: PropTypes.arrayOf(
      PropTypes.shape({
        // TODO: Remove the onOf this back in once we actually want to include
        // the searching of the metadata API
        brand_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
      })
    ),
    type: PropTypes.string,
  }),
  onChangeFeed: PropTypes.func,
  brands: PropTypes.arrayOf(
    PropTypes.shape({
      brand_id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  searchByType: PropTypes.func,
  includeAllBrands: PropTypes.bool,
  onChangeBrandsSelection: PropTypes.func,
};

export default IncludedContent;
